/// <amd-module name="VSSUI/Components/Dynamic/DynamicLink" />

import * as React from "react";
import { IDynamicLinkProps } from "../../Components/Dynamic/DynamicLink.Props";
import { UncheckedObserver } from "VSSUI/Observer";

/** @deprecated */
export class DynamicLink extends React.Component<IDynamicLinkProps> {
    public render(): JSX.Element {
        let linkProps = { ...this.props } as IDynamicLinkInternalProps;
        return (
            <UncheckedObserver {...linkProps} url={this.props.url}>
                <DynamicLinkInternal url="" children={this.props.children} />
            </UncheckedObserver>
        );
    }
}

interface IDynamicLinkInternalProps {
    url: string;
    href?: string;
}

class DynamicLinkInternal extends React.Component<IDynamicLinkInternalProps> {
    public render(): JSX.Element {
        let linkProps = { ...this.props };
        let childElement = null;
        if (this.props.url) {
            linkProps.href = this.props.url;
        }

        delete linkProps.url;

        if (this.props.url) {
            childElement = <a {...linkProps}>{this.props.children}</a>;
        } else {
            childElement = <span {...linkProps}>{this.props.children}</span>;
        }

        return childElement;
    }
}
